import React from 'react'
import OrganizationPupilsPage from './organization-pupils'

export const OrganizationPupilsWithPhotos = () => {
  return <OrganizationPupilsPage withPhotosPage />
}
